import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import directDebitForm from './common-form';

ReactModal.setAppElement('body');

export default directDebitForm({

    renderFlowProcess() {
        return <img width="600px" src="/static/directdebit-flow-co.png" alt="" />;
    },
    renderDocumentFields(){
        const { docTypes, country, errors, sending, showValidations, errorMessage, fields } = this.props;
        
        return ([
            <div key="1" className={`input ${errors['document_type'] ? 'invalid' : ''}`}>
                <label>Tipo de documento</label>
                <select
                    value={fields['document_type']}
                    name="document_type"
                    onChange={e => this.handleChange(e)}
                >
                    <option value="" />
                    {docTypes.map((doc, key) => (
                        <option key={key} value={doc.key}>
                            {doc.value}
                        </option>
                    ))}
                </select>
            </div>,
            <div key="2" className={`input ${errors['document_number'] ? 'invalid' : ''}`}>
                <label>Número de documento</label>
                <input name="document_number" value={fields.document_number} type="text" onChange={e => this.handleChange(e)} />

                {errors['document_number'] && <div className="error-tooltip">{errors['document_number']}</div>}
            </div>
        ])
    },
    renderBankFields(){
        const { docTypes, account_types, country, errors, sending, showValidations, errorMessage, fields, banks } = this.props;
        
        return ([
            <div key="1" className={`input ${errors['bank_code'] ? 'invalid' : ''}`}>
                <label>Banco</label>
                <select
                    value={fields['bank_code']}
                    name="bank_code"
                    onChange={e => this.handleChange(e)}
                >
                    <option value="" />
                    {banks.map((bank, key) => (
                        <option key={key} value={bank.code}>
                            {bank.name}
                        </option>
                    ))}
                </select>
            </div>,
            <div key="2" className={`input ${errors['account_type'] ? 'invalid' : ''}`}>
            <label>Tipo de cuenta</label>
            <select
                value={fields['account_type']}
                name="account_type"
                onChange={e => this.handleChange(e)}
            >
                <option value="" />
                {account_types.map((doc, key) => (
                    <option key={key} value={doc.key}>
                        {doc.value}
                    </option>
                ))}
            </select>
            </div>,
            <div key="3" className={`input ${errors['account_number'] ? 'invalid' : ''}`}>
                <label>Número de cuenta</label>
                <input name="account_number" value={fields.account_number} onChange={e => this.handleChange(e)} type="text" />
                {errors['account_number'] && <div className="error-tooltip">{errors['account_number']}</div>}
            </div>
        ])
    },
    renderAmountTitle() {
        return <label>Monto (pesos colombianos)</label>;
    },

    renderAttentionMessage() {
        return ([
            <p key="1">
                <i className="icon fa fa-exclamation-triangle" />
                Importante
            </p>,
            <p key="2">
                Si usted envía el formulario de débito automático después de las once de la mañana, su cuenta
                bancaria será debitada al segundo día hábil bancario y Booking será notificado al cuarto día hábil
                bancario.
            </p>,
            <p key="3">
                Si usted envía el formulario de debito automático antes de las once de la mañana su cuenta bancaria
                será debitada en el siguiente día hábil bancario y Booking será notificado al tercer día hábil
                bancario.
            </p>,
            <p key="4">
                Luego de enviado el formulario se le enviará un mail con la confirmación del envío y un link
                para chequear el estado del pago en cualquier momento.
            </p>]);
    }
});
